import { useCallback } from 'react';

export const FIELDS = {
  ENDDATE_FIELD: 'endDate',
  PROJECT_FIELD: 'project',
  STARTDATE_FIELD: 'startDate',
  SUBMIT_BUTTON: 'submitButton',
  USER_FIELD: 'user'
};

export const useOnChangeHandlers = (
  {
    onStartDateUpdate,
    onEndDateUpdate,
    onUserUpdate,
    onProjectUpdate,
    onAllocationStatusUpdate
  },
  setIsLoading,
  setIsExistingAllocationLoading,
  setFocusField,
  isPsaRmpTaskAllocation1And2025Q3WcagEnabled = false
) => {
  const onStartDateChange = useCallback(
    async event => {
      isPsaRmpTaskAllocation1And2025Q3WcagEnabled &&
        setFocusField(FIELDS.STARTDATE_FIELD);
      setIsLoading(true);
      await onStartDateUpdate(event);
      setIsLoading(false);
    },
    [
      isPsaRmpTaskAllocation1And2025Q3WcagEnabled,
      setFocusField,
      setIsLoading,
      onStartDateUpdate
    ]
  );

  const onEndDateChange = useCallback(
    async event => {
      isPsaRmpTaskAllocation1And2025Q3WcagEnabled &&
        setFocusField(FIELDS.ENDDATE_FIELD);
      setIsLoading(true);
      await onEndDateUpdate(event);
      setIsLoading(false);
    },
    [
      isPsaRmpTaskAllocation1And2025Q3WcagEnabled,
      setFocusField,
      setIsLoading,
      onEndDateUpdate
    ]
  );

  const onUserChange = useCallback(
    async event => {
      isPsaRmpTaskAllocation1And2025Q3WcagEnabled &&
        setFocusField(FIELDS.USER_FIELD);
      setIsLoading(true);
      await onUserUpdate(event);
      setIsLoading(false);
    },
    [
      isPsaRmpTaskAllocation1And2025Q3WcagEnabled,
      setFocusField,
      setIsLoading,
      onUserUpdate
    ]
  );

  const onProjectChange = useCallback(
    async event => {
      isPsaRmpTaskAllocation1And2025Q3WcagEnabled &&
        setFocusField(FIELDS.PROJECT_FIELD);
      if (event && event.isCreatable) return;

      setIsLoading(true);
      await onProjectUpdate(event);
      setIsLoading(false);
    },
    [
      isPsaRmpTaskAllocation1And2025Q3WcagEnabled,
      setFocusField,
      setIsLoading,
      onProjectUpdate
    ]
  );

  const onAllocationStatusChange = useCallback(
    async event => {
      setIsExistingAllocationLoading(true);
      await onAllocationStatusUpdate(event.target.value);
      setIsExistingAllocationLoading(false);
    },
    [onAllocationStatusUpdate, setIsExistingAllocationLoading]
  );

  return {
    onStartDateChange,
    onEndDateChange,
    onUserChange,
    onProjectChange,
    onAllocationStatusChange
  };
};

export default useOnChangeHandlers;
